import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { LoadingBar } from './shared/components/loading-bar/loading-bar';
import { StorageService } from './core/services/storage.service';
import { UserService } from './core/services/user.service';
import { STORAGE_KEYS, UserRole } from './core/constants/app-constants';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast, LoadingBar],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  private storage = inject(StorageService);
  private userService = inject(UserService);

  ngOnInit(): void {
    const token = this.storage.get(STORAGE_KEYS.ACCESS_TOKEN);
    if (token) {
      this.userService.loadProfile();
      if (this.storage.get(STORAGE_KEYS.USER_ROLE) === UserRole.VENDOR) {
        this.userService.checkSubscriptionStatus();
      }
    }
  }
}
